import React from 'react';
import { Grid } from '@mui/material';
import ProductCard from './ProductCard';
import { useNavigate } from 'react-router-dom';
import { products } from '../data/products';

const ProductList = () => {
  const navigate = useNavigate();

  const handleKnowMore = (productId) => {
    navigate(`/ProductInfo/${productId}`);
  };

  return (
    <Grid
      container
      spacing={4}
      justifyContent="center"
      alignItems="center"
      sx={{ padding: '20px' }}
    >
      {products.map((product, index) => (
        <Grid item key={index} xs={12} sm={6} md={4} display="flex" justifyContent="center">
          <ProductCard
            image={product.image}
            title={product.title}
            onKnowMore={() => handleKnowMore(product.id)}
          />
        </Grid>
      ))}
    </Grid>
  );
};

export default ProductList;
